module.exports = __webpack_public_path__ + "img/true@2x.1c40c26f.png";